// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Your Firebase configuration object
const firebaseConfig = {
    apiKey: "AIzaSyCkLmdAREhMpbl7j2W_ehxstXdPFgCn8yA",
    authDomain: "syracusesays.firebaseapp.com",
    projectId: "syracusesays",
    storageBucket: "syracusesays.appspot.com",
    messagingSenderId: "802219917383",
    appId: "1:802219917383:web:9e91bdaab317997ebb3162",
    measurementId: "G-TJDVSDJ0ZS"
  };

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
const auth = getAuth(app);
const db = getFirestore(app);

export { auth, db };
